// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartActionsStyles } from "@eisinc/Overrides/Widgets/Cart/CartActions";
import Download from "@eisinc/XDL/Icons/Download";
import Trash from "@eisinc/XDL/Icons/Trash";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import {
    color,
    createLinkIconStyles,
    hideElementOnPrint,
    modalButtonsActionStyles,
    xScreen,
} from "@eisinc/XDL/Utilities";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import X from "@insite/mobius/Icons/X";
import { css } from "styled-components";

cartActionsStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding-top: 12px;
        border-top: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 12px;
        }
        ${hideElementOnPrint}
    `,
};

cartActionsStyles.cancelApprovalWrapper = cartActionsStyles.discardEditWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding-top: 12px;
        border-top: 1px solid ${color("common.border")};
        justify-content: flex-end;
        ${hideElementOnPrint}
    `,
};

cartActionsStyles.leftSection = {
    css: css`
        display: flex;
        gap: 12px 32px;
        flex-wrap: wrap;
    `,
};

cartActionsStyles.rightSection = {
    css: css`
        display: flex;
        ${xScreen("lte", "md")} {
            justify-content: flex-end;
        }
    `,
};

cartActionsStyles.addAllToListLink = {
    ...createLinkIconStyles({
        icon: PlusCircle,
        linkStyles: { typographyProps: { weight: fontConfig.weight.medium } },
    }),
};

cartActionsStyles.requestCertificationsLink = {
    ...createLinkIconStyles({
        icon: PlusCircle,
        linkStyles: { typographyProps: { weight: fontConfig.weight.medium } },
    }),
};

cartActionsStyles.removeAllLink = {
    ...createLinkIconStyles({ icon: Trash, linkStyles: { typographyProps: { weight: fontConfig.weight.medium } } }),
};

cartActionsStyles.removeModalButtonsWrapper = {
    css: css`
        margin-top: 16px;
        ${modalButtonsActionStyles.buttonsGridItem?.css}
    `,
};

cartActionsStyles.discardEditLink = {
    ...createLinkIconStyles({
        icon: X,
        linkStyles: { typographyProps: { weight: fontConfig.weight.medium } },
    }),
};

cartActionsStyles.cancelApprovalLink = {
    ...createLinkIconStyles({
        icon: Download,
        linkStyles: { typographyProps: { weight: fontConfig.weight.medium } },
    }),
};

cartActionsStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

cartActionsStyles.removeButton = {
    ...modalButtonsActionStyles.submitButton,
};
